<div class="left" (click)="openJob()" (appDoubleClick)="navigate()">
  <div class="icon-wrapper">
    <i [class]="job.icon"></i>
  </div>

  <div class="content">
    <div class="customer-name">{{ job.code }} ({{ job.customer.name }})</div>
    <span class="job-details">
      {{ job.description }} | Created on {{ job.createdAt }}
    </span>
  </div>
</div>

<div class="right">
  <div class="estimator" (click)="openEstimator()" *ngIf="job.estimator">
    <p-avatar
      [label]="job.estimator.name.charAt(0).toUpperCase()"
      shape="circle"
      class="transparent-bg"
      ></p-avatar>
    {{ job.estimator.name }}
  </div>

  <div class="revenue">
    {{ job.discountedSubTotal }}
  </div>

  <p-button
    icon="pi pi-ellipsis-v"
    text="true"
    (click)="menu.toggle($event)"
    ></p-button>

  <p-tieredMenu
    #menu
    [popup]="true"
    appendTo="body"
    [model]="actions$ | async"
    ></p-tieredMenu>
</div>

